.select {
  --md-sys-color-primary: var(--pgm-sys-color-primary);
  --md-sys-color-secondary-container: var(--pgm-sys-color-secondary-container);
  --md-sys-color-on-secondary-container: var(--pgm-sys-color-on-secondary-container);
  --md-sys-color-surface-container: var(--pgm-sys-color-surface-container);
  --md-menu-container-color: var(--pgm-sys-color-surface-container);
  --md-sys-color-on-surface: var(--pgm-sys-color-on-surface);
  --md-sys-color-on-surface-variant: var(--pgm-sys-color-on-surface-variant);
  --md-sys-color-outline: var(--pgm-sys-color-outline);
  --md-sys-color-error: var(--pgm-sys-color-error);
  --md-sys-color-on-error-container: var(--pgm-sys-color-on-error-container);
  --md-sys-color-surface-container-highest: var(--pgm-sys-color-surface-container-highest);
  --md-sys-typescale-body-large-font: var(--pgm-sys-typescale-body-large-font);
  --md-sys-typescale-body-large-line-height: var(--pgm-sys-typescale-body-large-line-height);
  --md-sys-typescale-body-large-size: var(--pgm-sys-typescale-body-large-size);
  --md-sys-typescale-body-large-tracking: var(--pgm-sys-typescale-body-large-tracking);
  --md-sys-typescale-body-large-weight: var(--pgm-sys-typescale-body-large-weight);
  --md-sys-typescale-body-small-font: var(--pgm-sys-typescale-body-small-font);
  --md-sys-typescale-body-small-line-height: var(--pgm-sys-typescale-body-small-line-height);
  --md-sys-typescale-body-small-size: var(--pgm-sys-typescale-body-small-size);
  --md-sys-typescale-body-small-tracking: var(--pgm-sys-typescale-body-small-tracking);
  --md-sys-typescale-body-small-weight: var(--pgm-sys-typescale-body-small-weight);

  --md-filled-select-text-field-container-color: var(--pgm-sys-color-surface-container-highest);
  --md-filled-select-text-field-active-indicator-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-select-text-field-hover-active-indicator-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-select-text-field-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-select-text-field-hover-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-select-text-field-focus-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-select-text-field-error-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-select-text-field-error-hover-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-select-text-field-error-focus-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-select-text-field-input-text-font: var(--pgm-sys-typescale-body-large-font);
  --md-filled-select-text-field-input-text-line-height: var(--pgm-sys-typescale-body-large-line-height);
  --md-filled-select-text-field-input-text-size: var(--pgm-sys-typescale-body-large-size);
  --md-filled-select-text-field-input-text-weight: var(--pgm-sys-typescale-body-large-weight);
  --md-filled-field-leading-space: 12px;
  --md-filled-field-trailing-space: 12px;
  --md-filled-field-with-leading-content-leading-space: 12px;
  --md-filled-field-top-space: 8px;
  --md-filled-field-bottom-space: 8px;
  --md-filled-field-with-label-top-space: 8px;
  --md-filled-field-with-label-bottom-space: 8px;

  --md-outlined-select-text-field-outline-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-select-text-field-hover-outline-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-select-text-field-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-select-text-field-hover-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-select-text-field-focus-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-select-text-field-error-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-select-text-field-error-hover-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-select-text-field-error-focus-input-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-select-text-field-input-text-font: var(--pgm-sys-typescale-body-large-font);
  --md-outlined-select-text-field-input-text-line-height: var(--pgm-sys-typescale-body-large-line-height);
  --md-outlined-select-text-field-input-text-size: var(--pgm-sys-typescale-body-large-size);
  --md-outlined-select-text-field-input-text-weight: var(--pgm-sys-typescale-body-large-weight);
  --md-outlined-field-leading-space: 12px;
  --md-outlined-field-trailing-space: 12px;
  --md-outlined-field-with-leading-content-leading-space: 12px;
  --md-outlined-field-top-space: 8px;
  --md-outlined-field-bottom-space: 8px;
  --md-outlined-field-outline-label-padding: 4px;
  --md-outlined-field-label-text-padding-bottom: 8px;

  --md-menu-item-label-text-color: var(--pgm-sys-color-on-surface-variant);
  --md-menu-item-label-text-font: var(--pgm-sys-typescale-body-large-font);
  --md-menu-item-label-text-line-height: var(--pgm-sys-typescale-body-large-line-height);
  --md-menu-item-label-text-size: var(--pgm-sys-typescale-body-large-size);
  --md-menu-item-label-text-weight: var(--pgm-sys-typescale-body-large-weight);
  --md-menu-item-selected-label-text-color: var(--pgm-sys-color-on-surface-variant);

  display: inline-flex;
  max-width: 100%;
}

.selectFullWidth {
  width: 100%;
}

.option {
  color: var(--pgm-sys-color-on-surface-variant);
}

.optionText {
  color: var(--pgm-sys-color-on-surface-variant);
  font-family: var(--pgm-sys-typescale-body-large-font);
  font-size: var(--pgm-sys-typescale-body-large-size);
  font-weight: var(--pgm-sys-typescale-body-large-weight);
  letter-spacing: var(--pgm-sys-typescale-body-large-tracking);
  line-height: var(--pgm-sys-typescale-body-large-line-height);
}

.selectIcon {
  display: block;
  width: 24px;
  height: 24px;
  font-size: 24px;
  line-height: 24px;
}
